import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Wip from "../Components/Wip";

const Musics = () => {
    return (
        <div>
            <Navbar />
            <Wip />
            <Footer />
        </div>
    );
}

export default Musics;